/** Adresse de l’émetteur. */
import { Field } from "../../components/Field";
import { COUNTRIES } from "../clients/types";
import type { CompanyDraft } from "./types";

type CompanyAddressProps = {
  draft: CompanyDraft;
  setDraft: (next: CompanyDraft) => void;
};

export function CompanyAddress({ draft, setDraft }: CompanyAddressProps) {
  function set<K extends keyof CompanyDraft>(key: K, value: CompanyDraft[K]) {
    setDraft({ ...draft, [key]: value });
  }

  return (
    <div className="fx-co-grid">
        <Field label="Rue" required value={draft.address_line} onChange={(e) => set("address_line", e.target.value)} />
        <Field
          label="Appt / bâtiment"
          value={draft.address_line2}
          onChange={(e) => set("address_line2", e.target.value)}
        />
        <Field label="Ville" required value={draft.city} onChange={(e) => set("city", e.target.value)} />
        <Field label="Région / dép." value={draft.region} onChange={(e) => set("region", e.target.value)} />
        <Field label="Code postal" required value={draft.postal_code} onChange={(e) => set("postal_code", e.target.value)} />
        <label className="fx-field flex flex-col gap-1 text-xs">
          Pays
          <select
            className="rounded-md border px-2.5 py-2 text-sm"
            value={draft.country_code}
            onChange={(e) => set("country_code", e.target.value)}
          >
            {COUNTRIES.map((c) => (
              <option key={c.code} value={c.code}>
                {c.label}
              </option>
            ))}
          </select>
        </label>
    </div>
  );
}
